var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyAndPastePix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 87,
    viewBox: "0 0 105 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 44.7832H53.625C48.2402 44.7832 43.875 49.1484 43.875 54.5332V98.4082C43.875 103.793 48.2402 108.158 53.625 108.158H97.5C102.885 108.158 107.25 103.793 107.25 98.4082V54.5332C107.25 49.1484 102.885 44.7832 97.5 44.7832Z",
    stroke: "#433F3F",
    strokeWidth: 7.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 74.0337H19.5C16.9141 74.0337 14.4342 73.0065 12.6057 71.178C10.7772 69.3495 9.75 66.8696 9.75 64.2837V20.4087C9.75 17.8228 10.7772 15.3429 12.6057 13.5144C14.4342 11.6859 16.9141 10.6587 19.5 10.6587H63.375C65.9609 10.6587 68.4408 11.6859 70.2693 13.5144C72.0978 15.3429 73.125 17.8228 73.125 20.4087V25.2837",
    stroke: "#004A8A",
    strokeWidth: 7.02,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyAndPastePix);
export default __webpack_public_path__ + "static/media/copyAndPastePix.79cb463ef7ecf01a04a99f74ac015eea.svg";
export { ForwardRef as ReactComponent };